import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from '@mui/styles';

/*....Common loader use to show at center of screen untill the response from api not comes.....*/

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    height: "100vh",
    position: "absolute",
    justifyContent: "center",
    margin: "auto",
    width: "100%",
    zIndex: 1000000,
  },
  wrapper: {
    position: "relative",
  },
}));

export default function Loader() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
}
